<ion-content *ngIf="timeEntries?.length; else empty">
	<ion-list>
		<ion-item-group *ngFor="let timeEntry of timeEntries; index as index">
			<ion-item lines="full"
					  (click)="onClickToggleSection(index)"
					  mode="md"
					  button>
				<ion-text>
					{{ timeEntry.timeCodeDesc }}
				</ion-text>
				<div slot="end">
					<ion-text>
						{{ getDisplayTime(timeEntry.minutes) }}
					</ion-text>
					<ion-icon slot="end"
							  class="toggle-arrow"
							  [name]="
						isVisible(index)
							? 'chevron-up-outline'
							: 'chevron-down-outline'
					"></ion-icon>
				</div>



			</ion-item>
			<ion-item
				lines="none"
				*ngIf="isVisible(index)"
				color="light"
				mode="md"
			>
				<ion-grid>
					<!-- Pay Code -->
					<ion-row>
						<ion-col size="4" size-sm>
							<ion-label class="ion-text-wrap bold">
								Pay Code:
							</ion-label>
						</ion-col>
						<ion-col size="8" size-sm>
							<ion-text>{{ timeEntry.payCodeDesc }}</ion-text>
						</ion-col>
					</ion-row>
					<!-- Service -->
					<ion-row>
						<ion-col size="4" size-sm>
							<ion-label class="ion-text-wrap bold">
								Service:
							</ion-label>
						</ion-col>
						<ion-col size="8" size-sm>
							<ion-text>
								{{ timeEntry.customerServiceDesc }}
							</ion-text>
						</ion-col>
					</ion-row>
					<!-- Capital -->
					<ion-row>
						<ion-col size="4" size-sm>
							<ion-label class="ion-text-wrap bold">
								Capital:
							</ion-label>
						</ion-col>
						<ion-col size="8" size-sm>
							<ion-text>
								{{ timeEntry.capital ? "Yes" : "No" }}
							</ion-text>
						</ion-col>
					</ion-row>
					<!-- Note -->
					<ion-row>
						<ion-col size="4" size-sm>
							<ion-label class="ion-text-wrap bold">
								Note:
							</ion-label>
						</ion-col>
						<ion-col size="8" size-sm>
							<ion-text>
								<div class="scrollable note" scrollY="true">
									{{ timeEntry.note || "None" }}
								</div>
							</ion-text>
						</ion-col>
					</ion-row>
					<ion-row>
						<ion-col size="6" size-sm>
							<ion-button
								color="primary"
								expand="block"
								(click)="onClickEditTimeEntry(timeEntry)"
							>
								Edit
							</ion-button>
						</ion-col>
						<ion-col size="6" size-sm>
							<ion-button
								color="danger"
								expand="block"
								(click)="onClickDeleteTimeCode(timeEntry)"
							>
								Delete
							</ion-button>
						</ion-col>
					</ion-row>
				</ion-grid>
			</ion-item>
		</ion-item-group>
	</ion-list>
</ion-content>

<ng-template #empty>
	<app-empty-list-item
		message="No time codes exist for appointment"
	></app-empty-list-item>
</ng-template>

<ion-fab vertical="bottom" horizontal="end" slot="fixed">
	<ion-fab-button (click)="onClickAddTimeCode()" color="primary">
		<ion-icon name="add"></ion-icon>
	</ion-fab-button>
</ion-fab>
